

export const ongoeiProjects = [
    
    /*** UPDATES ON DATA */
    {
        id:1,
        photoIcon: [
            "./ongoing/Ongo_39.jpeg", "./ongoing/Ongo_39_1.jpeg", "./ongoing/Ongo_39_2.jpeg", "./ongoing/Ongo_39_3.jpg", 
        ],
        client: "HINDUSTAN STEELWORKS CONSTRUCTION LTD",
        customer:"NMDC, NAGARNAR",
        location:"JAGDALPUR (C.G.)",
        project:" Supply,Installation, Testing & Commissioning Services for complete Electrical, Illumination, Telecommunication & FDA System for Central Workshop (Pkg-28A) of 3.0 MTPA Intregrated Steel Plant, Nagarnar, Jagdalpur (C.G.) ",
        source: "eni"
    },
    {
        id:2,
        photoIcon: [
            "./ongoing/Ongo_35.jpg",
        ],
        client: "JINDAL STEEL ODISHA LTD",
        customer:"JINDAL STEEL ODISHA LTD",
        location:"ODISHA",
        project:"Installation, Testing & Commissioning of Electrical Equipment for Caster Plant JSOL Odisha",
        source:"eni"
    },
    {
        id:3,
        photoIcon: [
            "./ongoing/Ongo_36.jpg", 
        ],
        client: "BOKARO STEEL PLANT (SAIL)",
        customer:"BOKARO STEEL PLANT (SAIL)",
        location:"BOKARO, JHARKHAND",
        project:"Design engineering, Supply for Augmentation of 11KV Power Distribution System of Bokaro Steel Township",

        source:"eni"
    },
    {
        id:4,
        photoIcon: [
            "./ongoing/Ongo_37.jpg", 
        ],
        client: "JINDAL STEEL ODISHA LTD",
        customer:"JINDAL STEEL ODISHA LTD",
        location:"ODISHA",
        project:"Installation, Testing & Commissioning of Electrical & Instrumentation for  1X6 MTPA Pellet Plant JSOL Odisha",
        source:"eni"
    },
    {
        id:5,
        photoIcon: [
            "./ongoing/Ongo_38.jpg", "./ongoing/Ongo_38_1.jpg","./ongoing/Ongo_38_2.jpg","./ongoing/Ongo_38_3.jpg",
        ],
        client: "HTG ENGINEERING PVT. LTD.",
        customer:"ADANI POWER JHARKHAND LTD. (APJL)",
        location:"GODDA (JHARKHAND)",
        project:"Installation, Testing & Commissioning  of complete  Electrical System for Unit-1 and 400KV GIS for 2X800 MW Power Plant  Godda, Jharkhand",
        source:"eni"
    },
    
    {
        id:6,
        photoIcon: [
            "./ongoing/Ongo_40.jpg", 
        ],
        client: "MECON LIMITED",
        customer:"SAIL, BOKARO STEEL PLANT",
        location:"BOKARO, JHARKHAND",
        project:"Rebuilding of coke oven battery #8 Supply,Erection,Testing&Commissioning of Electrical Plant & Equipment (Pkg-SE-831) ",
        source:"eni"
    },
    

    
]